export default __webpack_public_path__ + "static/media/InductanceImg.1b6bfcc9.jpg";